require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-international-credit-union-development-educators.json") })
        }
      }, "path---articles-tags-international-credit-union-development-educators");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-international-credit-union-development-educators!./.cache/json/articles-tags-international-credit-union-development-educators.json
// module id = 1856
// module chunks = 231608221292675